<template>
  <div id="page-wrapper">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">
          {{$t('support.title')}}
          <a class="btn-settings" href=""><i class="fa fa-cog"></i></a>
        </h1>
      </div>
      <!-- /.col-lg-12 -->
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-4 col-xl-4 col-xxl-3">
        <div class="panel panel-default">
          <div class="panel-heading text-center">
            <h4 class="mrg-b-40">{{$t('support.subtitle')}}</h4>
          </div>
          <div class="panel-footer">
            <total-balance></total-balance>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-xl-8 col-xxl-9">
        <div class="panel panel-default">
         
          <div class="panel-body">
            
            <div class="form-group row">
              <div class="col-sm-12 col-md-12">
                <textarea :class="!$v.ticket.message.$invalid ? 'form-control' : 'form-control is-invalid'" rows="10" v-model="ticket.message" />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-12 col-md-12">
                <spin-button v-bind:disabled="$v.ticket.message.$invalid" id="btnSave" :button-text="$t('shared.buttons.submit')" :loading="isLoading" :loading-text="$t('shared.buttons.sending')" :onClick="createTicket"></spin-button>
                <button type="button" class="btn btn-default mrg-b-25" v-on:click="doCancel">{{$t('shared.buttons.cancel')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import SupportService from '@/services/SupportService';
  import swal from 'sweetalert2';
  import { required, minLength } from "vuelidate/lib/validators";

  let srv = new SupportService();


  export default {

    data() {
      return {
        isLoading: false,
        ticket: {}
      };
    },
    methods: {
      createTicket() {
        let t = this;
        t.isLoading = true;
        srv.createTicket(this.ticket).then((r) => {
          swal({
            position: 'top-end',
            type: 'success',
            title: r.data,
            showConfirmButton: false,
            timer: 2000
          });
          t.ticket = {};
          t.isLoading = false;
        }).catch((error) => {
          swal({
            type: 'error',
            title: 'Error',
            text: error.response.data.message

          });
          t.isLoading = false;
        });
      },
      doCancel(){
        this.$router.push('/client');
      }
    },
   validations : {
     ticket: {
       message: {
         required
       }
     }
   }

  };
</script>




// WEBPACK FOOTER //
// src/components/views/Support.vue